import { render, staticRenderFns } from "./_ErrorBox.vue?vue&type=template&id=13e00b2c"
import script from "./_ErrorBox.vue?vue&type=script&lang=ts"
export * from "./_ErrorBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports